import { debounceTime, first } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { TenantService } from '../services/tenant.service';
import { ArrayDataSource } from '../ui/arrayDataSource';

@Component({
    selector: 'sites-list',
    template: `
            <mat-toolbar>
                <h3>Sites</h3>
                <div>
                    <a mat-button color="primary" href="http://www.attensa.com/course-home-publisher-sites-2/" target="_blank">Guide</a>
                </div>            
                <span fxFlex></span>
                <mat-form-field style="font-size: 16px; font-weight: 400;">
                    <input matInput type="text" placeholder="Search Term" [(ngModel)]="params.term" (ngModelChange)="onSearchChange()">
                </mat-form-field>
                <div>
                    <button style="margin-top: 15px;" mat-button color="primary"  [routerLink]="['../', 'create']" matTooltip="Add New Site">Add Site</button>
                </div>
            </mat-toolbar>
            <spinner *ngIf="noTouching" style="padding-top:50px;"></spinner>
            <div fxLayout="column">
                <table mat-table #table
                       style="width: 100%"
                       [dataSource]="dataSource" 
                       matSort (matSortChange)="onSort($event)" 
                       [matSortActive]="params?.sort" 
                       [matSortDirection]="params?.dir"
                       [matSortDisableClear]="true">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="nameLower">Name</th>
                        <td mat-cell *matCellDef="let row">{{row.name}}</td>
                    </ng-container>
                    <ng-container matColumnDef="hostname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="hostName">Host Name</th>
                        <td mat-cell *matCellDef="let row">{{row.hostName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created">Created</th>
                        <td mat-cell *matCellDef="let row">{{row.created | date:'shortDate' }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <mat-menu #menu="matMenu">
                                <a mat-menu-item [routerLink]="['../', row.id]">
                                    <mat-icon>build</mat-icon>
                                    <span>Edit</span>
                                </a>
                            </mat-menu>
                            <button mat-icon-button class="edit-button" mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                

                    <tr mat-header-row *matHeaderRowDef="['name', 'hostname', 'created', 'actions']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['name', 'hostname', 'created', 'actions'];"></tr>
                </table>        
                <mat-paginator [length]="params?.totalElements" 
                                [pageIndex]="params?.page" 
                                [pageSize]="params?.rows"
                                (page)="onPage($event)"></mat-paginator>
            </div>
    `
})
export class SitesListComponent implements OnInit, OnDestroy {
    subscriptions: Array<Subscription> = [];
    dataSource: ArrayDataSource;
    noTouching: boolean;
    searchChanged: Subject<any> = new Subject();
    params: { page, rows, sort?, dir?, sortDirection?, term?, totalElements? } = { page: 0, rows: 20 };

    constructor(private tenantService: TenantService, 
                private route: ActivatedRoute, 
                private router: Router) {
        this.subscriptions.push(this.searchChanged.pipe(debounceTime(500)).subscribe(() => this.doSearch()));
    }

    onSearchChange = () => this.searchChanged.next();

    doSearch = () => this.router.navigate(['./'], { queryParams: { term: this.params.term, page: this.params.page, sort: this.params.sort, dir: this.params.dir }, relativeTo: this.route });

    onPage = $event => this.router.navigate(['./'], { queryParams: { term: this.params.term, page: $event.pageIndex, sort: this.params.sort, dir: this.params.dir }, relativeTo: this.route });

    onSort = $event => this.router.navigate(['./'], { queryParams: { term: this.params.term, sort: $event.active, dir: $event.direction }, relativeTo: this.route });

    ngOnInit() {
        this.subscriptions.push(this.route.queryParams
        .subscribe(params => {
            this.params.term = params['term'];
            this.params.page = +params['page'] || 0; 
            this.params.sort = params['dir'] ? params['sort'] : undefined;
            this.params.dir =  params['dir'] ? params['dir'] : undefined;
            this.params.sortDirection = this.params.dir ? this.params.dir.toUpperCase(): undefined;
            
            this.tenantService.getSubtenancies(this.params).pipe(first())
            .subscribe(response => {
                setTimeout(() => {
                    this.params.totalElements = response.totalElements;
                    this.dataSource = new ArrayDataSource(response.content);
                    this.noTouching = false;
                });            
            });
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
